@if (model && model.infoRequestExpirationDate) {
  <app-tooltip class="formGroupLabel" placement="left" [keepOpen]="keepTooltipOpen">
    <span class="fas fa-exclamation-triangle mx-2"
          [ngClass]="model.isInfoDeclared ? 'text-success' : 'text-warning'"></span>
    <div class="tooltipContent text-start row">
      <ng-container>
        <div class="col text-portbase-grey">Send proof before:</div>
        <div class="col">{{ model.infoRequestExpirationDate.substring(0, 10) }}</div>
        <div class="w-100"></div>
      </ng-container>
      <ng-container>
        <div class="col text-portbase-grey">Investigating office:</div>
        <div class="col">{{ model.investigatingOffice }}</div>
        <div class="w-100"></div>
      </ng-container>
      @if (!model.isInfoDeclared) {
        <div class="col pt-3">Open the declaration to declare proof</div>
      }
    </div>
  </app-tooltip>
}

@if (model && (model.mrnSentDate || model.mrnRejectDate || model.mrnAcceptDate)) {
  <app-tooltip class="formGroupLabel" placement="left" [keepOpen]="keepTooltipOpen">
    <span class="fas fa-file-download mx-2"
          [ngClass]="model.mrnAcceptDate ? 'text-success' : model.mrnRejectDate ? 'text-danger' : 'text-info'"></span>
    <div class="tooltipContent text-start row">
      @if (model.mrnSentDate) {
        <div class="col text-portbase-grey">MRN to terminal:</div>
        @if (model.mrnSentDate) {
          <div class="col">{{ model.mrnSentDate| timestamp }}</div>
        }
        <div class="w-100"></div>
      }
      @if (model.mrnAcceptDate) {
        <div class="col text-portbase-grey">Terminal accept:</div>
        <div class="col">{{ model.mrnAcceptDate | timestamp }}</div>
        <div class="w-100"></div>
      }
      @if (model.mrnRejectDate) {
        <div class="col text-portbase-grey">Terminal reject:</div>
        <div class="col">{{ model.mrnRejectDate | timestamp }}</div>
        <div class="w-100"></div>
      }
      @if (model.mrnRejectReason) {
        <div class="col text-portbase-grey">Reject reason:</div>
        <div class="col">{{ model.mrnRejectReason }}</div>
        <div class="w-100"></div>
      }
    </div>
  </app-tooltip>
}

@if (model && model.carrierRemarks) {
  <app-tooltip class="formGroupLabel" placement="left" [keepOpen]="keepTooltipOpen">
    <span class="fas fa-comment-dots mx-2"></span>
    <div class="tooltipContent text-start row">
      <span class="col pt-3">{{ model.carrierRemarks }}</span>
    </div>
  </app-tooltip>
}

@if (model && model.isReleased) {
  @if (model.inspectionStatus; as status) {
    <app-tooltip
      class="formGroupLabel" placement="left" [keepOpen]="keepTooltipOpen">
      <span class="fas fa-info-circle mx-2 text-info"></span>
      <div class="tooltipContent text-start row">
        @if (model.clearanceCode) {
          <div class="col text-portbase-grey">Clearance code:</div>
          <div class="col">{{ model.clearanceCode }}</div>
          <div class="w-100 pb-3"></div>
        }
        @if (model.actualDestinationCode) {
          <div class="col text-portbase-grey">Actual destination:</div>
          <div class="col">{{ model.actualDestinationCode }}</div>
          <div class="w-100 pb-3"></div>
        }
        @if (status.type) {
          <div class="col text-portbase-grey">Inspection type:</div>
          <div class="col">{{ refData.enumFormatter(status.type) }}</div>
          <div class="w-100"></div>
        }
        @if (status.inspectionDate) {
          <div class="col text-portbase-grey">Inspection date:</div>
          <div class="col">{{ status.inspectionDate | timestamp:"DD-MM-YYYY" }}</div>
          <div class="w-100"></div>
        }
        @if (status.inspectionExpiryDate) {
          <div class="col text-portbase-grey">Expiration date:</div>
          <div class="col">{{ status.inspectionExpiryDate | timestamp:"DD-MM-YYYY" }}</div>
          <div class="w-100"></div>
        }
        @if (status.inspectorName) {
          <div class="col text-portbase-grey">Inspector name:</div>
          <div class="col">{{ status.inspectorName }}</div>
          <div class="w-100"></div>
        }
        @if (status.bindingItinerary != null) {
          <div class="col text-portbase-grey">Binding itinerary:</div>
          <div class="col">{{ status.bindingItinerary ? 'Yes' : 'No' }}</div>
          <div class="w-100"></div>
        }
        @if (status.authorisationNumber) {
          <div class="col text-portbase-grey">Authorisation nr.:</div>
          <div class="col">{{ status.authorisationNumber }}</div>
          <div class="w-100"></div>
        }
      </div>
    </app-tooltip>
  }
}

@if (model && model.phase == accepted && model.departureModeOfTransport === NOT_SPECIFIED) {
  <app-tooltip class="formGroupLabel" placement="left" [keepOpen]="keepTooltipOpen">
    <span class="fas fa-exclamation-triangle mx-2 text-warning"></span>
    <div class="tooltipContent text-start row">
      <div class="col pt-3">Transport mode is "{{ refData.enumFormatter("NOT_SPECIFIED") }}". This requires a manual
        call to the customs to specify the transport mode in order to proceed
      </div>
    </div>
  </app-tooltip>
}

@if (phaseType(); as type) {
  <span class="mx-1 text-center">
    <span class="badge rounded-pill align-text-bottom" [ngClass]="'text-bg-' + type">
      {{ phase() | startCase }}
    </span>
  </span>
}

@if (model && model.typeCode; as typeCode) {
  <span>
    <span class="badge rounded-pill text-dark text-center align-text-bottom">{{ typeCode }}</span>
  </span>
}
